export const getInitials = (fullName: string): string => {
  const names = fullName.trim().split(/\s+/);
  const filteredNames = names.filter((_, index) => index === 0 || index === names.length - 1);
  return filteredNames
    .filter((name) => name.trim() !== '')
    .map((name) => name.trim()[0].toUpperCase())
    .join('');
};
